import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';

function FaceIdsFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors } } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name="face_ids"
      ref={ref}
      title={<div className="Body-2">{t('filters.event_filters.face_attributes.face_ids')}</div>}
    >
      <Control.Input
        id="face_ids"
        {...register('face_ids', { validate: validate.multipleUuid() })}
        errors={errors}
      />
    </FilterPopover>
  );
}

const FaceIdsFilterPopoverWithRef = forwardRef(FaceIdsFilterPopover);
export { FaceIdsFilterPopoverWithRef as FaceIdsFilterPopover };
